import React, { useContext, useEffect } from "react";
import PropTypes from "prop-types";
import { Row, Col, Form, TimePicker, Select } from "antd";
import { FormattedMessage } from "react-intl";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import dayjs from "dayjs";

import MQTTService from "../../../../services/mqtt";
import { selectors as NODE_SELECTORS } from "../../../../ducks/node";

import { required } from "../../../../lib/utils/formValidation";
import { MESSAGE_TYPE } from "../../../../lib/utils/constants";

import { FormV5Context } from "../../NodeChannelFormV5";

const { Item } = Form;

export default function AsRunSectionFormItem({ disabled, prefix }) {
  const form = useContext(FormV5Context);
  const { cwid } = useParams();
  const timeZoneList = useSelector(NODE_SELECTORS.getTimeZoneList);

  useEffect(() => {
    MQTTService.sendMessageV5({
      topic: `node/${cwid}/in`,
      message: {
        msgType: MESSAGE_TYPE.GET_TIME_ZONE_LIST,
      },
    });
  }, [cwid]);

  return (
    <Row gutter={24}>
      <Col span={8}>
        <Item
          name={[...prefix, "timezone"]}
          label={<FormattedMessage id="AsRunSectionFormItem.timezone" defaultMessage="Timezone" />}
          rules={[required]}
        >
          <Select disabled={disabled} options={timeZoneList} loading={timeZoneList.length === 0} showSearch />
        </Item>
      </Col>
      <Col span={6}>
        <Item
          name={[...prefix, "tvDayStart"]}
          label={<FormattedMessage id="AsRunSectionFormItem.tvDayStart" defaultMessage="TV day start" />}
          rules={[required]}
          getValueProps={(value) => ({
            value: value ? dayjs(value, "HH:mm") : null,
          })}
          normalize={(value) => value && dayjs(value).format("HH:mm")}
        >
          <TimePicker
            format="HH:mm"
            needConfirm={false}
            showNow={false}
            onChange={(_time, timeString) => {
              form.setFieldValue([...prefix, "tvDayStart"], timeString);
            }}
            disabled={disabled}
          />
        </Item>
      </Col>
    </Row>
  );
}

AsRunSectionFormItem.propTypes = {
  prefix: PropTypes.arrayOf(PropTypes.string).isRequired,
  disabled: PropTypes.bool.isRequired,
};
